<ng-container *ngIf="showCompleteLoader">
<div class="loading-mask">
  <img src="assets/Loading.svg" alt="Loading...">
  <span *ngIf="showFileScanLoader | async" class="scan-loader-text">
    {{ "AntivirusScan.Common.Dialog.LoaderText" | translate }}
  </span>
</div>
</ng-container>
